export const searchTargets = ['title', 'organizationName', 'siteName'];
